module.exports = __webpack_public_path__ + "static/media/wheel-sensor-siping.46be1db8.png";